import {Popover} from '@mui/material';
import React, {ReactNode} from 'react';

interface IProps {
    anchorPosition: { top: number, left: number },
    open: boolean,
    onClose: () => void,
    children: ReactNode,
}

const PopoverActionAddPointMutateSingleVoyage = ({
                                                     anchorPosition,
                                                     open,
                                                     onClose,
                                                     children,
                                                 }: IProps) => {
    return (
        <Popover
            open={open}
            anchorReference="anchorPosition"
            anchorPosition={anchorPosition}
            onClose={onClose}
        >
            {children}
        </Popover>
    );
};


export default PopoverActionAddPointMutateSingleVoyage;